<div class="video-editor">
  <!-- {{'hien_thi' | translate}} tiêu đề {{'mo_rong' | translate}} -->
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate }}</span>
  </div>
  <!-- Dropdown menu -->
  <div class="editor-content" *ngIf="!isViewAll">
    <app-position-out-config [elementChoosing]="objectChoosing" [device]="device"
      [id_parent_choose]="objectChoosing.id_block? objectChoosing.id_block: objectChoosing.id_object"></app-position-out-config>

    <app-width-height-config   [device]="device"   [elementChoosing]="objectChoosing" [width]="class['video']['width']" [height]="class['video']['height']"
      (changeWidthHeight)="changeWidthHeight($event)"></app-width-height-config>
    <ul nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">
      <!-- Upload video -->
      <li nz-submenu nzTitle="{{'hien_thi'| translate}}" [(nzOpen)]="openMap.menu1"
        (nzOpenChange)="openHandler('menu1')">
        <div class="upload-video" *ngIf="!isViewAll">
          <!-- Lựa chọn {{'hien_thi' | translate}} cho các thiết bị -->
          <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
          </app-hide-show-config>
        </div>
      </li>

      <li nz-submenu nzTitle="Video" [(nzOpen)]="openMap.menu2"
        (nzOpenChange)="openHandler('menu2')">
        <!-- Quản lý dữ liệu ở trang Admin -->
        <app-data-admin-management-config [objectChoosing]="objectChoosing" >
        </app-data-admin-management-config>

        <div class="mt-2" *ngIf="!objectChoosing.dynamic_data">
          <div class="mb-1">
            <div class="title">Video</div>
            <nz-select [(ngModel)]="config['video'].is_upload_video" (ngModelChange)="updateConfig()">
              <nz-option [nzValue]="0" nzLabel="{{'tai_video_len' | translate}}"></nz-option>
              <nz-option [nzValue]="1" nzLabel="{{'chon_tu_thu_vien' | translate}}"></nz-option>
              <nz-option [nzValue]="2" nzLabel="{{'duong_dan_video' | translate}}"></nz-option>
            </nz-select>
          </div>
          <!-- Trường hợp tải video từ máy -->
          <!-- Upload input -->
          <div class="custom" *ngIf="config['video'].is_upload_video == 0">
            <label for="upload" style="width: 100%" (click)="openUpload()">
              <input type="file" (change)="onUpload($event)" id="upload" name="file" hidden />
              <button [disabled]="!config.video['is_load_video']"
                [ngClass]="{ disable: !config.video['is_load_video'] }" class="upload-background-video">
                <i class="bi bi-plus-circle"></i> {{'tai_video_len' | translate}}
              </button>
            </label>
          </div>

          <!-- Trường hợp tải video từ thư viện -->
          <button *ngIf="config['video'].is_upload_video == 1" [disabled]="checkDisableUploadImage(1)"
            (click)="openLibrary()" [ngClass]="{ disable: checkDisableUploadImage(1) }" class="upload-background-video">
            <i class="bi bi-upload"></i>{{'chon_tu_thu_vien' | translate}}
          </button>

          <!-- Trường hợp chọn video từ 1 đường dẫn bất kì -->
          <div class="title" *ngIf="config['video'].is_upload_video == 2">
            <textarea class="input custom-textarea w-100" name="background-video" id="background-video"
              placeholder="{{'nhap_duong_dan_video' | translate}}" [(ngModel)]="objectChoosing.staticdata.src" (blur)="saveVideo()">
            </textarea>
            <!-- Nếu video chứa id_subproject thì đã là video trên server rồi nên sẽ disable -->
            <button style="width: 100%;" nz-button nzType="primary" (click)="isShowConfirmPopup = true"
              [disabled]="staticdata.src.includes(id_subproject)">
              {{'chuyen_video_len_server'  | translate}}
            </button>
          </div>
        </div>
        <!-- Khi tải video lên  -->
        <div *ngIf="config['video'].is_upload_video == 0" class="config-img" style="margin-top: 15px">
          <nz-select [(ngModel)]="objectChoosing.compress" (ngModelChange)="updateStaticData()"
            nzPlaceHolder="{{'cau_hinh_cho_video_hien_thi'  | translate}}" nzAllowClear>
            <nz-option [nzValue]="false" nzLabel="{{'khong_nen_video_sau_khi_tai_len'  | translate}}"></nz-option>
            <nz-option [nzValue]="true" nzLabel="{{'nen_video_sau_khi_tai_len'  | translate}}"></nz-option>
          </nz-select>
          <ng-container *ngIf="objectChoosing.compress">
            <div style="margin-top: 10px">
              <label class="label-item" for="compress-screen">
                <input type="radio" [value]="1" id="compress-screen" name="compress"
                  [(ngModel)]="objectChoosing.compress_type" (ngModelChange)="handleChangeCompressType($event)" />
                  {{'nen_video_theo_ti_le_khung_anh'  | translate}}
              </label>
              <label class="label-item" for="compress-frame">
                <input type="radio" [value]="2" id="compress-frame" name="compress"
                  [(ngModel)]="objectChoosing.compress_type" (ngModelChange)="handleChangeCompressType($event)" />
                  {{'nen_video_theo_ti_le_man_hinh'  | translate}}
              </label>
            </div>
          </ng-container>
          <ng-container *ngIf="!objectChoosing.compress">
            <div style="margin-top: 10px">
              <label class="label-item" for="shared">
                <input type="radio" [value]="3" id="shared" name="compress" [(ngModel)]="objectChoosing.compress_type"
                  (ngModelChange)="handleChangeCompressType($event)" />
                  {{'video_dung_chung_cho_cac_thiet_bi'  | translate}}
              </label>
              <label class="label-item" for="ratio">
                <input type="radio" [value]="4" id="ratio" name="compress" [(ngModel)]="objectChoosing.compress_type"
                  (ngModelChange)="handleChangeCompressType($event)" />
                  {{'video_dung_rieng_cho_tung_thiet_bi'  | translate}}
              </label>
            </div>
          </ng-container>
        </div>

        <!-- Vị trí khi cuộn trang -->
        <div class="my-4">
          <div class="title mb-2">{{'vi_tri_khi_cuon_trang'  | translate}}</div>
          <nz-select [(ngModel)]="config['position_onscroll']['type']" (ngModelChange)="updateConfig()">
            <nz-option [nzValue]="0" nzLabel="{{'binh_thuong' | translate }}"></nz-option>
            <nz-option [nzValue]="1" nzLabel="{{'co_dinh_o_top' | translate }}"></nz-option>
          </nz-select>
          <div *ngIf="config['position_onscroll']['type'] != '0'" class="mt-3">
            <div class="title mb-1">{{'canh_le' | translate}}</div>
            <div class="config-name mt-0">
              <p>{{'tren' | translate}}</p>
              <nz-input-number [nzMin]="-100" [nzMax]="1000" [(ngModel)]="config['position_onscroll']['top']"
                (nzBlur)="updateConfig()">
              </nz-input-number>
            </div>
          </div>
        </div>
      </li>

      <!-- Cấu hình lật video -->
      <li nz-submenu nzTitle="{{'cau_hinh_xoay'| translate}}" [(nzOpen)]="openMap.menu4" (nzOpenChange)="openHandler('menu4')">
        <div class="editor-field-body">
          <div class="mb-3">
            <div class="field-row-sub">
              <div style="display: flex; gap: 4px; width: 100%">
                <button nz-button nzType="primary" nzSize="default" (click)="handleSetTransform('y')"
                  class="btn_transform">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                    <path fill="currentColor"
                      d="M15.97 15.25h-2.72c-5.3 0-9.5-2.15-9.5-4.5s4.2-4.5 9.5-4.5c3.03 0 5.82.7 7.62 1.86a.75.75 0 1 0 .81-1.26c-2.06-1.33-5.13-2.1-8.43-2.1-6.02 0-11 2.55-11 6s4.98 6 11 6h2.8l-2.3 2.3a.75.75 0 1 0 1.07 1.05l2.83-2.82c.68-.69.68-1.8 0-2.48l-2.83-2.83a.75.75 0 0 0-1.06 1.06l2.21 2.22z">
                    </path>
                  </svg>
                  <p class="m-0">{{ 'ngang' | translate }}</p>
                </button>
                <button nz-button nzType="primary" nzSize="default" (click)="handleSetTransform('x')"
                  class="btn_transform">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                    <path fill="currentColor"
                      d="M15.25 8.35v2.4c0 5.3-2.15 9.5-4.5 9.5s-4.5-4.2-4.5-9.5c0-3.03.7-5.82 1.86-7.62a.75.75 0 1 0-1.26-.81c-1.33 2.06-2.1 5.13-2.1 8.43 0 6.02 2.55 11 6 11s6-4.98 6-11V8.27l2.3 2.3A.75.75 0 1 0 20.1 9.5l-2.82-2.83a1.75 1.75 0 0 0-2.48 0L11.97 9.5a.75.75 0 1 0 1.06 1.06l2.22-2.22z">
                    </path>
                  </svg>
                  <p class="m-0">{{ 'doc' | translate }}</p>
                </button>
              </div>
            </div>
          </div>
          <div class="field-row mb-3">
            <div class="field-row-sub">
              <div style="display: flex; gap: 4px; width: 100%">
                <button nz-button nzType="primary" nzSize="default" class="btn_transform"
                  (click)="handleSetTransform('-z')">
                  <span nz-icon nzType="rotate-left" nzTheme="outline"></span>
                  <p class="m-0">{{ 'trai' | translate }}</p>
                </button>
                <button nz-button nzType="primary" nzSize="default" class="btn_transform"
                  (click)="handleSetTransform('z')">
                  <span nz-icon nzType="rotate-right" nzTheme="outline"></span>
                  <p class="m-0">{{ 'phai' | translate }}</p>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="view">
          <p class="discover_text" (click)="openViewAll(style_fields[6])"
            style="cursor: pointer; text-align: left; margin: 0">
            {{ 'mo_rong' | translate }} &#8594;
          </p>
        </div>
      </li>

      <li nz-submenu nzTitle="Cài đặt video" [(nzOpen)]="openMap.menu10" (nzOpenChange)="openHandler('menu10')">
        <div style="display: flex;  justify-content: space-between; align-items: flex-end;">
          <p style="font-weight: 500; font-size: 14px">
            Lặp lại
          </p>
          <nz-switch [(ngModel)]="config['video_config']['is_loop']"
            (ngModelChange)="updateConfig()">
          </nz-switch>
        </div>
        <div style="display: flex;  justify-content: space-between; align-items: flex-end;" class="mt-2">
          <p style="font-weight: 500; font-size: 14px">
            Tự động phát
          </p>
          <nz-switch [(ngModel)]="config['video_config']['is_autoplay']"
            (ngModelChange)="updateConfig()">
          </nz-switch>
        </div>
        <div style="display: flex;  justify-content: space-between; align-items: flex-end;" class="mt-2">
          <p style="font-weight: 500; font-size: 14px">
            {{'hien_thi' | translate}} điều khiển
          </p>
          <nz-switch [(ngModel)]="config['video_config']['is_controls']"
            (ngModelChange)="updateConfig()">
          </nz-switch>
        </div>
        <div style="display: flex;  justify-content: space-between; align-items: flex-end;" class="mt-2">
          <p style="font-weight: 500; font-size: 14px">
            Tắt âm thanh
          </p>
          <nz-switch [(ngModel)]="config['video_config']['is_muted']"
            (ngModelChange)="updateConfig()">
          </nz-switch>
        </div>
      </li>

      <!-- Cấu hình object-fit -->
      <li nz-submenu nzTitle="{{'do_bao_phu'| translate}}" [(nzOpen)]="openMap.menu5" (nzOpenChange)="openHandler('menu5')">
        <app-object-fit-config [device]="device" [class]="class" [objectFitClass]="class['video__iframe']"
          [style_field]="style_fields[2]" (isViewAll)="openViewAll($event)" [objectChoosing]="objectChoosing">
        </app-object-fit-config>
      </li>

      <!-- Cấu hình hình dạng viền -->
      <li nz-submenu nzTitle="{{'kieu_vien'| translate}}" [(nzOpen)]="openMap.menu6" (nzOpenChange)="openHandler('menu6')">
        <app-borders-config [device]="device" [class]="class" [borderClass]="class['video__iframe']"
          [id_object]="objectChoosing._id" [elementChoosing]="objectChoosing">
        </app-borders-config>
        <!-- Nút {{'mo_rong' | translate}} -->

        <div class="item-border my-3 cursor-pointer" style="float: right">
          <p class="m-0 title-border" (click)="openViewAll(style_fields[3])">
            {{ 'mo_rong' | translate }} &#8594;
          </p>
        </div>
      </li>

      <!-- Tạo bóng -->
      <li nz-submenu nzTitle="{{'do_bong'| translate}}" [(nzOpen)]="openMap.menu7" (nzOpenChange)="openHandler('menu7')">
        <!-- Cấu hình bóng -->
        <div class="editor-field-body">
          <div class="field-row">
            <div class="field-row-sub field-row__switch">
              <span> {{'ap_dung' | translate}} </span>
              <nz-switch [(ngModel)]="config.check_shadow" (ngModelChange)="handleSetShadow()"></nz-switch>
            </div>
          </div>
          <div class="field-row">
            <div class="item">
              <p class="m-0">{{'ngang' | translate}}</p>
              <nz-input-number [(ngModel)]="config['box-shadow'].box_shadow_x" [nzMin]="0" [nzStep]="1"
                [nzDisabled]="!config.check_shadow" (ngModelChange)="handleSetShadow()"></nz-input-number>
            </div>
            <nz-slider [(ngModel)]="config['box-shadow'].box_shadow_x" (nzOnAfterChange)="handleSetShadow()"
              [nzMin]="-100" [nzStep]="0.1"></nz-slider>
          </div>
          <div class="field-row">
            <div class="item">
              <p class="m-0">{{'doc' | translate}}</p>
              <nz-input-number [nzStep]="1" [(ngModel)]="config['box-shadow'].box_shadow_y"
                [nzDisabled]="!config.check_shadow" (ngModelChange)="handleSetShadow()"></nz-input-number>
            </div>
            <nz-slider [(ngModel)]="config['box-shadow'].box_shadow_y" (nzOnAfterChange)="handleSetShadow()"
              [nzMin]="-100" [nzStep]="0.1"></nz-slider>
          </div>
          <div class="field-row">
            <div class="item">
              <p class="m-0 title">{{'kich_thuoc_bong' | translate}}</p>
              <nz-input-number [nzStep]="1" [(ngModel)]="config['box-shadow'].box_shadow_width"
                [nzDisabled]="!config.check_shadow" (ngModelChange)="handleSetShadow()"></nz-input-number>
            </div>
            <nz-slider [(ngModel)]="config['box-shadow'].box_shadow_width" (nzOnAfterChange)="handleSetShadow()"
              [nzMin]="-100" [nzStep]="0.1"></nz-slider>
          </div>
          <div class="field-row">
            <div class="item">
              <p class="m-0 title">{{'do_nhoe' | translate}}</p>
              <nz-input-number [nzStep]="1" [(ngModel)]="config['box-shadow'].box_shadow_blur"
                [nzDisabled]="!config.check_shadow" (ngModelChange)="handleSetShadow()"></nz-input-number>
            </div>
            <nz-slider [(ngModel)]="config['box-shadow'].box_shadow_blur" (nzOnAfterChange)="handleSetShadow()"
              [nzMin]="0" [nzMax]="100" [nzStep]="1"></nz-slider>
          </div>
          <div class="field-row">
            <div class="item w-100">
              <p class="m-0 w-50">{{'mau_sac' | translate}}</p>
              <input class="input-color w-50" type="button" [cpOKButton]="true" [(colorPicker)]="config['box-shadow'].box_shadow_color"
                [style.background]="config['box-shadow'].box_shadow_color" (colorPickerClose)="handleSetShadow()"
                [cpWidth]="'230px'" [disabled]="!config.check_shadow" />
            </div>
          </div>
        </div>

      </li>
      <!-- {{'hieu_ung' | translate}} -->
      <!-- Cấu hình {{'hieu_ung' | translate}} -->
      <li nz-submenu nzTitle="{{'hieu_ung'| translate}}" [(nzOpen)]="openMap.menu8" (nzOpenChange)="openHandler('menu8')">
        <app-choose-animations-config [type]="type" [elementChoosing]="objectChoosing" (openAnimationDetail)="openAnimationDetail($event)"
          [id_object]="objectChoosing._id" [device]="device" [class]="class" [config]="config" [staticdata]="staticdata"
          [cursorClass]="class['video']" [effect_hover]="effect_hover" [customize]="customize" [type]="'object'">
        </app-choose-animations-config>
      </li>
      <!-- Thêm liên kết -->
      <li *ngIf="!objectChoosing.dynamic_data" nz-submenu nzTitle="{{'lien_ket'| translate}}" [(nzOpen)]="openMap.menu9"
        (nzOpenChange)="openHandler('menu9')">
        <app-link-page-config [staticdata]="staticdata" [id_object]="objectChoosing._id"></app-link-page-config>
      </li>
    </ul>
  </div>

  <!-- {{'mo_rong' | translate}} -->
  <div class="view-more" *ngIf="isViewAll">
    <!-- Cấu hình chi tiết viền -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 4">
      <app-borders-radius-config [device]="device" [class]="class" [borderRadiusClass]="class['video__iframe']"
        [id_object]="objectChoosing._id">
      </app-borders-radius-config>
    </div>

    <!-- Cấu hình chi tiết {{'hieu_ung' | translate}} -->
    <div class="editor_effect-hover" *ngIf="currentViewAll.index == 6">
       <app-animations-config [type]="type" [elementChoosing]="objectChoosing" [device]="device" [staticdata]="staticdata" [id_object]="objectChoosing._id"
        [customize]="customize"></app-animations-config>
    </div>
    <!-- {{'mo_rong' | translate}} hình dạng video-->
    <div class="editor-field-body p-0 mt-2" *ngIf="currentViewAll.index == 7">
      <div class="editor-field-body">
        <div class="field-row">
          <!-- <div class="d-flex justify-content-between mt-2 align-items-start">
            <p class="font-weight-bold">{{'hien_thi' | translate}} trục đối tượng</p>
            <nz-switch [(ngModel)]="config.video.show_axis" (ngModelChange)="updateConfig()"></nz-switch>
          </div> -->
          <p style="font-weight: 500; font-size: 16px">{{'lat_hinh'| translate}}</p>
          <div class="field-row-sub">
            <div style="display: flex; gap: 4px; width: 100%">
              <span nz-button nzType="primary" nzSize="default" (click)="handleSetTransform('y')" class="btn_transform">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                  <path fill="currentColor"
                    d="M15.97 15.25h-2.72c-5.3 0-9.5-2.15-9.5-4.5s4.2-4.5 9.5-4.5c3.03 0 5.82.7 7.62 1.86a.75.75 0 1 0 .81-1.26c-2.06-1.33-5.13-2.1-8.43-2.1-6.02 0-11 2.55-11 6s4.98 6 11 6h2.8l-2.3 2.3a.75.75 0 1 0 1.07 1.05l2.83-2.82c.68-.69.68-1.8 0-2.48l-2.83-2.83a.75.75 0 0 0-1.06 1.06l2.21 2.22z">
                  </path>
                </svg>
                <p class="m-0">{{'ngang'| translate}}</p>
              </span>
              <button nz-button nzType="primary" nzSize="default" (click)="handleSetTransform('x')"
                class="btn_transform">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                  <path fill="currentColor"
                    d="M15.25 8.35v2.4c0 5.3-2.15 9.5-4.5 9.5s-4.5-4.2-4.5-9.5c0-3.03.7-5.82 1.86-7.62a.75.75 0 1 0-1.26-.81c-1.33 2.06-2.1 5.13-2.1 8.43 0 6.02 2.55 11 6 11s6-4.98 6-11V8.27l2.3 2.3A.75.75 0 1 0 20.1 9.5l-2.82-2.83a1.75 1.75 0 0 0-2.48 0L11.97 9.5a.75.75 0 1 0 1.06 1.06l2.22-2.22z">
                  </path>
                </svg>
                <p class="m-0">{{'doc'| translate}}</p>
              </button>
            </div>
          </div>
        </div>
        <div class="field-row">
          <div class="item mt-2" style="min-height: 32px">
            <p class="m-0">{{'ngang'| translate}}</p>
            <nz-input-number 
              [nzMin]="-360" 
              [nzMax]="360" 
              [(ngModel)]="config['transform'].transform_rotateY"
              (ngModelChange)="SetTransform()"
              (nzBlur)="updateObject()"
            >
            </nz-input-number>
          </div>
          <nz-slider
            [nzMin]="-360"
            [nzMax]="360"
            [(ngModel)]="config['transform'].transform_rotateY"
            (nzOnAfterChange)="updateObject()"
            (ngModelChange)="SetTransform()"
          >
          </nz-slider>
        </div>
        <div class="field-row">
          <div class="item" style="min-height: 32px">
            <p class="m-0">{{'doc'| translate}}</p>
            <nz-input-number
              [nzMin]="-360"
              [nzMax]="360"
              [(ngModel)]="config['transform'].transform_rotateX"
              (ngModelChange)="SetTransform()"
              (nzBlur)="updateObject()"
            >
            </nz-input-number>
          </div>
          <nz-slider
            [nzMin]="-360"
            [nzMax]="360"
            [(ngModel)]="config['transform'].transform_rotateX"
            (nzOnAfterChange)="updateObject()" 
            (ngModelChange)="SetTransform()"
          >
          </nz-slider>
        </div>
      </div>
      <br />
      <!-- Xoay hình video -->
      <div class="editor-field-body">
        <div class="field-row mb-3">
          <div style="justify-content: space-between; align-items: center">
            <p class="mt-1" style="font-weight: 500; font-size: 16px">
              {{'xoay_hinh'| translate}}
            </p>
            <div style="display: flex; justify-content: space-between; gap: 4px">
              <button class="btn_transform" nz-button nzType="primary" nzSize="default"
                (click)="handleSetTransform('-z')">
                <span nz-icon nzType="rotate-left" nzTheme="outline"></span>
                <p class="m-0">{{'trai'| translate}}</p>
              </button>
              <button nz-button nzType="primary" nzSize="default" class="btn_transform"
                (click)="handleSetTransform('z')">
                <span nz-icon nzType="rotate-right" nzTheme="outline"></span>
                <p class="m-0">{{'phai'| translate}}</p>
              </button>
            </div>
          </div>
        </div>
        <div class="field-row">
          <div class="item" styl="min-height: 32px">
            <p class="m-0">{{'xoay'| translate}}</p>
            <nz-input-number 
              [nzMin]="-360" 
              [nzMax]="360" 
              [(ngModel)]="config['transform'].transform_rotateZ"
              (ngModelChange)="SetTransform()"
              (nzBlur)="updateObject()"
              >
            </nz-input-number>
          </div>
          <nz-slider
            [nzMin]="-360"
            [nzMax]="360"
            [(ngModel)]="config['transform'].transform_rotateZ"
            (nzOnAfterChange)="updateObject()"
            (ngModelChange)="SetTransform()">
          </nz-slider>
        </div>
      </div>
      <br />
      <!-- Cấu hình Độ nghiêng -->
      <div class="editor-field-body">
        <div class="field-row mb-3">
          <div class="item">
            <p class="m-0" style="font-weight: 500; font-size: 16px">
              {{'do_nghieng'| translate}}
            </p>
          </div>
        </div>
        <div class="field-row">
          <div class="item" style="min-height: 32px">
            <p class="m-0">{{'ngang'| translate}}</p>
            <nz-input-number
              [nzMin]="-360"
              [nzMax]="360"
              [(ngModel)]="config['transform'].transform_skewY"
              (ngModelChange)="SetTransform()"
              (nzBlur)="updateObject()"
              >
            </nz-input-number>
          </div>
          <nz-slider
            [nzMin]="-360"
            [nzMax]="360"
            [(ngModel)]="config['transform'].transform_skewY"
            (nzOnAfterChange)="updateObject()"
            (ngModelChange)="SetTransform()"
            >
          </nz-slider>
        </div>
        <div class="field-row">
          <div class="item" style="min-height: 32px">
            <p class="m-0">{{'doc'| translate}}</p>
            <nz-input-number
              [nzMin]="-360"
              [nzMax]="360"
              [(ngModel)]="config['transform'].transform_skewX"
              (ngModelChange)="SetTransform()"
              (nzBlur)="updateObject()"
            >
            </nz-input-number>
          </div>
          <nz-slider
            [nzMin]="-360"
            [nzMax]="360"
            [(ngModel)]="config['transform'].transform_skewX"
            (nzOnAfterChange)="updateObject()"
            (ngModelChange)="SetTransform()"
          >
          </nz-slider>
        </div>
      </div>
    </div>
    <!-- {{'mo_rong' | translate}} cấu hình độ bao phủ -->
    <div class="editor-field-body p-1" *ngIf="currentViewAll.index == 3">
      <div class="field-row">
        <div class="field-row-sub">
          <p class="m-0" style="font-weight: 500; font-size: 16px">
            {{'vi_tri_hinh_anh'| translate}}
          </p>
        </div>
      </div>
      <div class="field-row">
        <div class="d-flex justify-content-between py-1">
          <p class="m-0">{{'ngang'| translate}}</p>
          <nz-input-number [(ngModel)]="config.video.object_x" [nzMin]="0" [nzStep]="1"
            (ngModelChange)="handleSetPositionVideo()"></nz-input-number>
        </div>
      </div>
      <div class="field-row">
        <div class="d-flex justify-content-between py-1">
          <p class="m-0">{{'doc'| translate}}</p>
          <nz-input-number [(ngModel)]="config.video.object_y" [nzMin]="0" [nzStep]="1"
            (ngModelChange)="handleSetPositionVideo()"></nz-input-number>
        </div>
      </div>
      <div class="field-row mt-2">
        <div class="field-row-sub">
          <p class="m-0" style="font-weight: 500; font-size: 16px">
            {{'phong_thu_hinh_anh'| translate}}
          </p>
        </div>
      </div>
      <div class="field-row">
        <div class="d-flex justify-content-between py-1">
          <p class="m-0">{{'do_co_gian'| translate}}</p>
        </div>
        <nz-slider [(ngModel)]="class['video__iframe'].transfrom_scale" (nzOnAfterChange)="scale()"
          (ngModelChange)="(class['video__iframe'].transfrom_scale)" [nzMin]="0.1" [nzMax]="2"
          [nzStep]="0.1"></nz-slider>
      </div>
    </div>
  </div>

  <nz-modal nzTitle="{{ 'thong_bao' | translate}}" [(nzVisible)]="isShowConfirmPopup" [nzContent]="modalContent"
    (nzOnCancel)="handleCancelConfirm()" (nzOnOk)="handleOkConfirm()" [nzFooter]="modalFooter">
    <ng-template #modalContent>
      <p>{{"ban_co_muon_chuyen_video_len_server_khong" | translate}}?</p>
    </ng-template>
    <ng-template #modalFooter>
      <button nz-button nzType="default" (click)="handleCancelConfirm()">{{'khong' | translate}}</button>
      <button nz-button nzType="primary" (click)="handleOkConfirm()" [nzLoading]="isConfirmLoading">{{'dong_y' | translate}}</button>
    </ng-template>
  </nz-modal>

</div>